var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCashpayment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 292,
    height: 327,
    viewBox: "0 0 292 327",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M282.819 156.637L236.735 163.593C234.975 163.859 233.769 165.466 234.041 167.182L238.387 194.551C238.659 196.267 240.307 197.443 242.067 197.178L288.151 190.221C289.911 189.956 291.117 188.349 290.845 186.632L286.499 159.264C286.227 157.547 284.579 156.371 282.819 156.637Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M234.745 171.601L287.203 163.684",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M283.101 172.666L274.627 173.945L276.516 185.843L284.99 184.564L283.101 172.666Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M278.067 175.888C279.857 173.81 282.798 175.195 282.109 181.645L284.731 182.912L284.986 184.533L276.518 185.815L276.17 183.647L279.367 182.434C279.367 182.434 276.383 177.848 278.067 175.888Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M259.688 190.44C259.688 190.44 265.812 190.488 264.057 189.297C262.303 188.105 262.04 186.9 263.532 186.879C265.023 186.858 267.524 189.65 267.325 187.946C267.126 186.242 268.206 187.35 268.412 187.461C268.618 187.572 270.387 186.879 270.472 187.08C270.558 187.281 270.437 187.842 276.198 186.976",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M239.192 176.922L264.881 173.043",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.647 179.759L254.779 177.473",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M240.443 184.765L261.55 181.578",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M246.993 166.038L272.753 162.145",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.6618 148.489L59.256 137.273L79.3681 231.427L18.1508 244.229L1.6618 148.489Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8348 230.793L76.9313 220.008",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6921 212.004L40.515 217.255",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3656 207.281L56.8405 208.507",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M66.6657 197.66L23.1166 205.626",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M9.19226 192.224L68.804 181.965",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "1.41 2.83"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M72.5338 228.379L36.3234 235.777",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M71.454 225.402L54.4322 228.381",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2469 175.766L32.3877 181.536",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8883 169.297L50.3757 171.119",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M59.327 164.805L15.8348 172.979",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M55.377 142.957L43.6337 145.326",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8347 151.098L5.70404 153.016",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M9.39124 158.468C9.6025 157.766 9.96537 157.116 10.4555 156.561C10.9456 156.007 11.5516 155.561 12.2329 155.254",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8953 164.804C12.6373 164.658 11.4745 164.078 10.618 163.168C9.76159 162.258 9.2683 161.078 9.22778 159.844",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8453 163.629C17.1241 164.262 16.2266 164.671 15.2664 164.807",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3926 154.777C15.3073 154.807 16.1987 155.066 16.9799 155.531C17.7612 155.996 18.4056 156.65 18.8506 157.43C19.2955 158.21 19.5258 159.089 19.5189 159.981C19.5121 160.873 19.2683 161.749 18.8115 162.522",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7506 156.085C23.8058 155.794 22.868 155.462 21.9089 155.254",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8068 156.745C32.004 158.609 27.5142 156.911 26.207 156.523",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M25.12 151.801L33.5172 153.727C33.3822 154.274 33.2757 154.828 33.1691 155.375",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M20.964 153.72C21.8591 151.642 21.5039 150.95 23.7346 151.455",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M123.429 300.761L134.547 304.086L126.285 294.596C130.814 289.686 133.407 283.367 133.602 276.766",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M109.938 304.953C113.664 303.794 117.181 302.071 120.36 299.848",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0351 284.789C70.3102 300.174 87.744 309.651 105.981 305.965",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M69.6921 267.449C68.9921 268.745 68.3983 270.093 67.916 271.481",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M133.069 271.436C129.801 256.051 112.36 246.574 94.1308 250.266C85.8529 251.851 78.3927 256.181 73.017 262.521",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M113.724 265.796C108.474 260.22 101.32 264.085 98.3435 269.745C93.4274 265.588 85.3072 264.57 82.565 271.657C77.933 283.592 93.7755 290.873 101.107 293.505C101.938 293.81 102.62 294.066 103.189 294.253C103.65 293.872 104.19 293.387 104.844 292.805C110.641 287.7 122.576 275.203 113.724 265.796Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M157.38 38.7244L146.645 34.3672L153.927 44.5917C148.95 49.0529 145.758 55.0914 144.919 61.6325",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M171.205 35.8086C167.383 36.6165 163.713 38 160.328 39.9095",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M211.933 59.902C210.193 44.2674 193.775 33.184 175.261 35.1721",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M207.579 76.9188C208.391 75.6933 209.103 74.4079 209.71 73.0742",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M144.919 66.9922C146.66 82.6129 163.078 93.6825 181.591 91.7221C189.986 90.9179 197.837 87.3081 203.813 81.5046",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M186.212 76.5552C194.421 72.2707 197.513 62.309 193.119 54.3051C188.725 46.3011 178.509 43.2859 170.3 47.5704C162.092 51.8549 158.999 61.8166 163.393 69.8205C167.787 77.8245 178.004 80.8397 186.212 76.5552Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M171.851 64.1395L176.895 68.7807L185.307 54.6562",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M199.331 218.629C199.331 218.629 196.801 248.471 200.46 255.71C204.119 262.949 205.952 312.409 204.311 318.63C204.311 318.63 216.09 321.525 220.75 317.411C225.41 313.296 232.578 317.258 244.386 313.254C256.193 309.25 247.675 220.382 247.675 220.382L248.037 188.053L228.565 171.137L199.331 218.629Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M215.031 232.986C214.958 233.199 214.839 233.395 214.683 233.561C212.168 235.882 201.433 238.458 192.212 240.315C184.575 241.86 178.004 242.906 178.004 242.906C178.004 242.906 172.945 201.918 172.945 197.609C172.945 193.3 164.79 123.544 164.79 123.544L184.341 122.719L210.278 121.625C210.278 121.625 210.435 123.488 210.697 126.744C212.41 147.484 218.292 224.805 215.031 232.986Z",
    fill: "#374DA0"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M215.031 232.99L192.212 237.541L183.595 239.266C181.257 237.029 179.474 236.987 179.474 236.987L178.764 230.718L177.648 220.459L167.83 130.198C169.962 128.764 171.013 125.626 171.013 125.626L184.156 125.162L206.925 124.352L210.683 126.721C212.409 147.488 218.292 224.809 215.031 232.99Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M215.031 232.99L192.212 237.541L183.595 239.266C181.257 237.029 179.474 236.987 179.474 236.987L178.764 230.718L177.648 220.459L167.83 130.198C169.962 128.764 171.013 125.626 171.013 125.626L184.156 125.162L206.925 124.352L210.683 126.721C212.409 147.488 218.292 224.809 215.031 232.99Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M180.682 206.412L188.298 206.398L188.305 208.719L186.188 209.453L181.307 209.973L180.682 206.412Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M181.151 211.199L186.749 211.012L188.184 211.677L188.113 214.759L181.577 214.829L181.151 211.199Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M182.046 216.122L188.44 215.672L188.369 218.006L185.278 219.073L182.01 218.893L182.046 216.122Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M182.43 220.059L187.594 220.315L188.063 221.603L187.31 223.023L182.692 223.314L181.897 221.118L182.43 220.059Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M188.383 224.566L189.093 226.582C189.207 226.796 189.266 227.034 189.266 227.275C189.266 227.516 189.207 227.753 189.093 227.968C188.961 228.115 188.793 228.227 188.603 228.292C188.414 228.358 188.211 228.375 188.013 228.342C187.616 228.307 187.225 228.175 186.827 228.155C185.626 228.106 184.525 229.069 183.346 228.847C182.884 227.601 181.719 225.772 183.296 225.211C183.588 225.121 188.553 225.024 188.383 224.566Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M188.362 230.238C188.474 230.718 188.555 231.204 188.603 231.693C188.675 232.002 188.665 232.325 188.573 232.629C188.481 232.934 188.31 233.21 188.077 233.432C187.774 233.594 187.436 233.682 187.09 233.688L182.984 234.048C182.924 233.292 182.912 232.533 182.948 231.776C183.19 230.876 183.019 230.952 183.893 230.585C185.278 230.01 186.941 230.924 188.362 230.238Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M173.428 132.25C173.428 132.25 174.977 146.846 175.048 149.734",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M176.767 132.406L177.492 140.449",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M188.34 129.371L189.278 138.799L190.592 138.924L190.166 129.461L188.34 129.371Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M215.031 232.99C214.957 233.203 214.839 233.399 214.683 233.565C212.168 235.885 201.433 238.462 192.212 240.319V234.084L178.792 230.732L176.767 230.226L177.677 220.472L181.151 183.204L184.184 125.189L184.312 122.723L210.278 121.629C210.278 121.629 210.435 123.492 210.697 126.748C212.41 147.488 218.292 224.809 215.031 232.99Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M215.031 232.986C214.958 233.199 214.839 233.395 214.683 233.561C212.168 235.882 201.433 238.458 192.212 240.315C184.575 241.86 178.004 242.906 178.004 242.906C178.004 242.906 172.945 201.918 172.945 197.609C172.945 193.3 164.79 123.544 164.79 123.544L184.341 122.719L210.278 121.625C210.278 121.625 210.435 123.488 210.697 126.744C212.41 147.484 218.292 224.805 215.031 232.986Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M228.792 325.999C228.955 324.537 226.597 303.569 226.554 301.29C226.441 295.055 224.629 286.874 224.629 286.874C222.1 280.571 220.132 266.044 213.383 256.727C206.634 247.41 206.641 236.451 205.518 227.148C204.396 217.845 204.673 218.649 204.957 210.392C205.162 204.189 204.88 197.98 204.112 191.82C203.551 186.334 202.428 176.684 204.112 172.188C205.796 167.693 210.2 166.647 215.024 171.149C219.848 175.652 221.816 194.113 221.816 196.392C221.816 198.671 221.816 205.792 223.506 208.535C223.506 208.535 233.062 203.769 233.062 202.453C233.062 201.137 232.777 189.506 234.184 188.883L228.565 171.149L239.221 167.457C241.227 169.211 242.96 171.242 244.365 173.484C245.567 175.34 246.574 177.311 247.37 179.365C251.867 190.995 259.092 199.107 260.584 202.453C262.075 205.799 260.584 232.371 260.584 237.31C260.584 242.25 257.316 265.019 257.401 268.85C257.465 271.621 259.383 281.928 261.294 289.832C262.004 292.88 266.317 314.964 266.977 316.716L228.792 325.999Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M237.203 187.712C237.132 189.201 238.958 201.075 238.958 201.075C240.223 204.032 233.317 214.118 233.317 214.118C231.826 214.936 231.186 220.006 231.186 220.006C226.512 218.995 215.805 208.5 215.805 208.5C215.805 208.5 214.541 212.802 213.12 223.449C211.699 234.096 220.707 259.387 224.544 276.851C228.38 294.314 226.554 301.269 226.554 301.269C226.441 295.034 224.629 286.854 224.629 286.854C222.1 280.55 220.132 266.024 213.383 256.707C206.634 247.389 206.641 236.452 205.518 227.148C204.396 217.845 204.673 218.649 204.957 210.392C205.162 204.189 204.88 197.98 204.112 191.82C203.551 186.334 202.428 176.684 204.112 172.188C205.796 167.693 210.2 166.647 215.024 171.149C219.848 175.652 221.816 194.113 221.816 196.392C221.816 198.671 221.816 205.792 223.506 208.535C223.506 208.535 233.062 203.769 233.062 202.453C233.062 201.137 232.777 189.506 234.184 188.883L228.565 171.149L239.221 167.457C241.227 169.211 242.96 171.242 244.365 173.484C240.919 180.203 237.274 186.784 237.203 187.712Z",
    fill: "#374DA0"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M255.12 270.689C255.589 266.533 256.989 256.655 257.877 250.489C256.79 255.304 255.035 257.742 255.035 257.742C255.035 257.742 258.061 222.414 258.36 220.259C258.658 218.105 261.713 208.421 260.591 202.422C262.083 205.761 260.591 232.34 260.591 237.279C260.591 242.218 257.323 264.988 257.408 268.819C257.472 271.59 260.52 289.247 262.431 297.151C258.324 291.332 254.651 274.866 255.12 270.689Z",
    fill: "#374DA0"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M266.963 316.685C264.718 310.382 257.507 272.629 257.422 268.819C257.337 265.009 260.605 242.211 260.605 237.279C260.605 232.347 262.097 205.761 260.605 202.422C259.113 199.083 251.888 190.964 247.391 179.334C245.691 174.786 242.897 170.702 239.242 167.426L228.586 171.118L234.205 188.851C232.785 189.475 233.083 201.106 233.083 202.422C233.083 203.738 223.528 208.504 223.528 208.504C221.837 205.733 221.837 198.64 221.837 196.361C221.837 194.081 219.869 175.614 215.045 171.118C210.221 166.622 205.81 167.654 204.133 172.157C202.456 176.66 203.572 186.302 204.133 191.789C204.902 197.956 205.185 204.172 204.978 210.381C204.694 218.638 204.41 217.821 205.54 227.138C206.669 236.455 206.662 247.414 213.404 256.731C220.146 266.048 222.121 280.574 224.65 286.878C224.65 286.878 229.424 320.523 228.813 326.002",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M223.506 208.5C223.506 208.5 225.19 216.168 228.984 220.006",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M224.529 212C224.529 212 231.634 214.12 234.603 214.251",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M233.062 202.417C233.062 202.417 238.12 200.138 241.352 201.51",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M234.184 188.842C234.184 188.842 238.12 188.489 238.958 186.57",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M214.683 258.684C214.683 258.684 222.242 267.834 224.487 272.489",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M258.637 218.637C257.372 225.903 255.682 245.77 255.12 249.331",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M261.052 204.93C261.265 211.51 259.631 214.933 259.631 214.933",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M202.947 112.852L255.035 126.249C255.035 126.249 236.727 180.426 233.012 187.145L226.803 234.375C226.803 234.375 193.526 232.948 178.224 228.438C178.224 228.438 187.9 179.255 188.419 172.695C188.937 166.135 202.947 112.852 202.947 112.852Z",
    fill: "#374DA0"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M191.743 169.783L203.224 121.923C203.224 121.923 208.161 119.534 210.072 117.352L247.391 127.701C247.391 127.701 247.505 131.268 249.643 133.554L230.81 186.471L226.242 225.478C226.242 225.478 220.167 225.949 219.585 230.327C219.585 230.327 199.892 231.366 186.685 227.971C186.685 227.971 185.129 223.24 182.749 220.248L191.743 169.783Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M191.743 169.783L203.224 121.923C203.224 121.923 208.161 119.534 210.072 117.352L247.391 127.701C247.391 127.701 247.505 131.268 249.643 133.554L230.81 186.471L226.242 225.478C226.242 225.478 220.167 225.949 219.585 230.327C219.585 230.327 199.892 231.366 186.685 227.971C186.685 227.971 185.129 223.24 182.749 220.248L191.743 169.783Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M201.298 172.274C201.298 172.274 204.687 159.805 216.622 162.042C228.557 164.28 221.816 179.644 221.816 179.644C221.816 179.644 221.887 192.044 212.204 190.333C203.806 188.85 199.331 184.355 201.298 172.274Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M207.763 126.477C207.763 126.477 204.154 140.726 203.224 143.469",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M210.854 127.707L208.751 135.521",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M237.203 133.188L244.386 135.654L243.597 137.849H241.352L236.571 136.755L237.203 133.188Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M236.01 137.852L241.352 139.493L242.475 140.588L241.352 143.469L235.165 141.412L236.01 137.852Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M235.164 142.785L241.352 144.448L240.478 146.623H237.203L234.184 145.39L235.164 142.785Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M234.184 146.617L238.958 148.536V149.901L237.765 151.002L233.317 149.769V147.435L234.184 146.617Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M238.255 152.802V154.936C238.292 155.171 238.272 155.411 238.197 155.637C238.121 155.863 237.993 156.069 237.822 156.238C237.645 156.332 237.447 156.381 237.246 156.381C237.045 156.381 236.847 156.332 236.671 156.238C236.308 156.072 235.96 155.822 235.619 155.677C234.504 155.24 233.133 155.788 232.067 155.206C232.067 153.883 231.591 151.784 233.268 151.742C233.545 151.763 238.255 153.287 238.255 152.802Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M236.287 158.143C236.233 158.632 236.143 159.115 236.017 159.591C235.861 160.208 235.555 160.893 234.923 161.06C234.582 161.115 234.233 161.086 233.907 160.976L229.914 159.951C230.108 159.222 230.345 158.505 230.625 157.804C231.165 157.035 230.98 157.049 231.925 156.986C233.459 156.924 234.71 158.33 236.287 158.143Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M222.803 128.676L220.409 137.854L221.603 138.402L224.487 129.355L222.803 128.676Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M192.802 190.305L200.176 192.168L199.579 194.412L197.341 194.606L192.482 193.907L192.802 190.305Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M192.02 195.059L197.484 196.25L198.706 197.248L197.839 200.212L191.495 198.675L192.02 195.059Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M191.615 200.043L197.924 201.179L197.242 203.416L193.981 203.694L190.862 202.717L191.615 200.043Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M190.969 203.945L195.899 205.462L196.02 206.827L194.926 208.018L190.386 207.16L190.18 204.839L190.969 203.945Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M195.565 209.765L195.757 211.892C195.815 212.123 195.817 212.365 195.761 212.597C195.706 212.83 195.595 213.046 195.437 213.229C195.27 213.337 195.078 213.402 194.878 213.417C194.677 213.433 194.477 213.399 194.294 213.319C193.917 213.187 193.583 212.965 193.193 212.855C192.049 212.508 190.727 213.166 189.64 212.674C189.513 211.358 188.866 209.308 190.528 209.149C190.784 209.135 195.608 210.25 195.565 209.765Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M194.081 215.259C194.071 215.763 194.023 216.265 193.939 216.762C193.832 217.385 193.59 218.099 192.979 218.314C192.644 218.397 192.292 218.397 191.956 218.314L187.893 217.621C188.03 216.877 188.212 216.141 188.44 215.418C188.909 214.608 188.724 214.635 189.662 214.497C191.154 214.282 192.518 215.577 194.081 215.259Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M223.506 221.976C223.506 221.976 225.197 203.592 225.197 201.742",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M220.132 221.156C220.132 221.156 220.842 211.596 220.97 209.934",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M206.954 214.254L204.673 225.136H206.954L208.609 214.254H206.954Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M233.133 186.876C228.202 185.871 223.805 184.396 220.551 182.269C220.551 182.269 222.91 188.878 231.271 200.141L226.774 234.375C226.774 234.375 205.057 233.447 188.646 230.711C193.69 216.857 202.854 190.603 201.767 185.4C200.297 178.258 205.49 169.828 205.49 169.828C221.908 166.946 237.829 154.845 248.755 144.613C243.192 160.65 235.598 182.124 233.133 186.876Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M202.947 112.852L255.035 126.249C255.035 126.249 236.727 180.426 233.012 187.145L226.803 234.375C226.803 234.375 193.526 232.948 178.224 228.438C178.224 228.438 187.9 179.255 188.419 172.695C188.937 166.135 202.947 112.852 202.947 112.852Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M231.826 220.702L224.487 272.489C222.853 269.102 218.398 263.324 216.097 260.436C215.244 259.355 214.676 258.683 214.676 258.683L213.376 256.73C206.634 247.413 206.634 236.454 205.511 227.137C204.389 217.82 204.666 218.637 204.95 210.38C205.157 204.182 204.877 197.978 204.112 191.822C203.551 186.336 202.428 176.686 204.112 172.191C204.936 169.988 206.421 168.616 208.282 168.325C210.143 168.034 212.545 168.866 215.024 171.152C219.848 175.647 221.816 194.115 221.816 196.394C221.816 198.673 221.816 205.794 223.506 208.538C223.506 208.503 228.039 216.864 231.826 220.702Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M212.822 253.04C214.356 254.952 215.4 257.709 216.097 260.439C215.244 259.358 214.676 258.686 214.676 258.686L213.376 256.733C206.634 247.415 206.634 236.457 205.511 227.14C204.389 217.823 204.666 218.64 204.95 210.383C205.157 204.185 204.877 197.981 204.112 191.825C203.551 186.339 202.428 176.689 204.112 172.193C204.936 169.991 206.421 168.619 208.282 168.328C211.834 169.312 215.386 172.838 216.622 178.871C218.754 188.999 209.142 180.818 206.918 189.401C204.694 197.983 207.927 200.297 209.255 202.458C210.584 204.62 208.886 209.385 206.918 215.786C204.95 222.187 208.609 247.783 212.822 253.04Z",
    fill: "#374DA0"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M231.825 220.703C228.032 216.865 223.506 208.504 223.506 208.504C221.816 205.733 221.816 198.64 221.816 196.36C221.816 194.081 219.848 175.614 215.024 171.118C210.2 166.622 205.788 167.654 204.112 172.157C202.435 176.66 203.551 186.302 204.112 191.789C204.881 197.956 205.163 204.172 204.957 210.381C204.673 218.638 204.389 217.821 205.518 227.138C206.648 236.455 206.641 247.414 213.383 256.731L214.683 258.684C214.683 258.684 222.242 267.835 224.487 272.49",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M206.954 198.785C206.954 198.785 213.397 195.537 216.622 195.814",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M108.552 109.946C108.552 109.946 92.2552 92.4484 91.1328 91.3746C90.0103 90.3009 89.1649 71.6392 86.0674 63.4236C82.97 55.208 81.471 6.96726 81.471 6.96726C81.471 6.96726 78.5227 3.4067 70.2107 5.32552C61.8988 7.24434 53.7502 3.67686 44.4791 8.88608C35.2081 14.0953 53.189 88.6038 53.189 88.6038L71.4398 145.316L108.552 109.946Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M119.749 110.075C119.749 110.075 112.446 155.566 104.83 161.592C100.432 165.056 93.5767 166.649 87.4954 166.441C83.0908 166.289 79.084 165.208 76.7254 163.248C71.1059 158.586 63.2273 156.12 59.3057 153.107C55.3842 150.093 55.37 139.405 52.8409 130.358C50.3118 121.311 46.6531 121.041 45.8148 112.001C44.9765 102.961 41.5948 75.2868 35.4852 67.6046C29.3755 59.9224 29.2334 53.9027 26.7043 46.0889C24.1752 38.275 5.67575 10.0053 5.67575 10.0053L50.7735 1C50.7735 1 55.2066 18.8928 59.9522 33.4884C62.2043 40.4155 64.5274 46.6084 66.4739 49.781C70.2117 55.9178 73.4493 62.3312 76.157 68.9623C81.2579 74.1716 84.0499 85.7122 84.8953 95.8189L96.9725 102.386C106.258 104.859 119.749 110.075 119.749 110.075Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M119.749 110.073C119.749 110.073 112.445 155.563 104.83 161.59C100.432 165.054 93.5766 166.647 87.4953 166.439C73.0737 162.975 69.1948 155.134 67.2411 153.236C64.641 150.707 61.2238 135.301 63.0993 126.338C64.9749 117.374 63.6251 114.056 62.0763 109.678C58.645 99.9799 69.1095 94.7568 70.1894 91.0854C71.2692 87.4141 70.8998 66.882 66.1897 60.2042C63.689 56.6506 57.2454 38.3352 59.9593 33.5C62.2113 40.4272 64.5344 46.62 66.481 49.7927C70.2187 55.9294 73.4563 62.3429 76.1641 68.974C81.2649 74.1832 84.0569 85.7238 84.9023 95.8306L96.9795 102.397C106.258 104.857 119.749 110.073 119.749 110.073Z",
    fill: "#374DA0"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6765 106.875C64.6765 106.875 62.1331 109.791 59.8882 109.791",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M70.2108 116.73C70.2108 116.73 67.4756 122.397 63.1065 123.658",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M65.3514 149.939C65.3514 149.939 71.5392 147.334 72.5196 142.949",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9867 102.391C96.9867 102.391 95.438 104.309 95.438 105.854",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M50.802 1C50.802 1 60.4495 39.9098 66.5024 49.8087C70.2401 55.9455 73.4777 62.3589 76.1855 68.99C81.2863 74.1993 84.0783 85.7468 84.9237 95.8536L97.0009 102.42C106.272 104.887 119.735 110.096 119.735 110.096C119.735 110.096 112.431 155.586 104.816 161.613C97.1998 167.64 82.4017 167.889 76.7183 163.234C71.0349 158.579 63.2202 156.106 59.2987 153.093C55.3771 150.079 55.3629 139.391 52.8338 130.344C50.3047 121.297 46.646 121.027 45.8077 111.987C44.9694 102.947 41.5877 75.273 35.4781 67.5907C29.3684 59.9085 29.2263 53.8888 26.6972 46.075C24.1681 38.2612 5.67575 10.0053 5.67575 10.0053",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M136.834 107.129L62.2469 219.079L79.8512 220.991L133.339 223.159L138.817 123.581L136.834 107.129Z",
    fill: "#263238",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M136.834 107.119L129.943 221.244L62.2469 219.076L67.5893 131.627L69.2517 104.473L98.7485 105.629L136.834 107.119Z",
    fill: "#757575"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M119.813 208.098C124.364 208.098 128.053 204.501 128.053 200.063C128.053 195.625 124.364 192.027 119.813 192.027C115.261 192.027 111.572 195.625 111.572 200.063C111.572 204.501 115.261 208.098 119.813 208.098Z",
    fill: "#BFBFBF",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeMiterlimit: 10
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M117.489 194.738L123.073 195.452",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M115.99 196.055L124.381 196.851",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M115.06 204.125L123.457 204.922",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M118.733 197.874C118.963 197.93 119.207 197.898 119.414 197.783C119.62 197.668 119.773 197.48 119.841 197.258L120.466 197.32L119.834 203.104L118.903 203.007L119.386 198.595L118.676 198.519L118.733 197.874Z",
    fill: "#263238"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M121.837 198.122C122.207 198.122 122.377 198.392 122.335 198.773V198.842L121.972 198.808V198.745C121.972 198.579 121.93 198.503 121.809 198.489C121.688 198.475 121.61 198.538 121.596 198.704C121.582 198.87 121.638 199.016 121.866 199.251C121.981 199.346 122.072 199.467 122.13 199.603C122.188 199.739 122.212 199.887 122.2 200.034C122.157 200.415 121.944 200.609 121.567 200.567C121.191 200.526 121.027 200.29 121.063 199.916V199.771L121.418 199.805V199.978C121.418 200.145 121.468 200.214 121.589 200.228C121.709 200.242 121.795 200.186 121.809 200.02C121.823 199.854 121.766 199.708 121.539 199.473C121.423 199.377 121.333 199.257 121.275 199.121C121.217 198.985 121.193 198.837 121.205 198.69C121.255 198.274 121.475 198.053 121.837 198.122Z",
    fill: "#263238"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M122.505 198.219L123.684 198.337L123.642 198.676L123.244 198.634L123.024 200.657L122.647 200.622L122.867 198.593L122.47 198.551L122.505 198.219Z",
    fill: "#263238"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M102.534 112.186L89.3183 109.374C88.9771 109.301 88.6402 109.512 88.5658 109.845L86.7679 117.878C86.6934 118.211 86.9097 118.539 87.2508 118.612L100.466 121.424C100.807 121.496 101.144 121.286 101.219 120.953L103.017 112.919C103.091 112.587 102.875 112.258 102.534 112.186Z",
    fill: "white",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M93.5908 117.187C93.5876 117.131 93.5731 117.077 93.5481 117.027C93.5412 117 93.5412 116.971 93.5481 116.944C93.559 116.923 93.5764 116.906 93.5979 116.896C93.7897 116.729 93.5552 116.508 93.3705 116.466C93.3067 116.451 93.2398 116.452 93.1764 116.468C93.1129 116.485 93.055 116.518 93.0082 116.563L93.1574 116.023L93.811 116.161L93.882 115.829L92.9017 115.621C92.8809 115.668 92.8666 115.716 92.859 115.767C92.859 115.815 92.923 115.829 92.923 115.884C92.923 115.94 92.923 115.933 92.923 115.961C92.9359 116.001 92.9637 116.036 93.0011 116.058C93.0366 116.058 93.0722 116.12 93.065 116.161C93.0699 116.175 93.0699 116.19 93.065 116.203C93.0381 116.267 92.9908 116.32 92.9301 116.355C92.9021 116.361 92.8769 116.375 92.859 116.397V116.438C92.859 116.487 92.8022 116.515 92.7596 116.542C92.7169 116.57 92.6104 116.792 92.5678 116.944L92.923 117.02V116.951C92.9585 116.785 93.0508 116.743 93.1645 116.764C93.2782 116.785 93.3492 116.868 93.3066 117.034L93.1929 117.547C93.1929 117.706 93.0722 117.755 92.9514 117.727C92.8306 117.699 92.7738 117.63 92.8093 117.464L92.859 117.249L92.5038 117.173L92.4612 117.367C92.4337 117.442 92.4229 117.522 92.4296 117.601C92.4363 117.681 92.4604 117.758 92.5001 117.828C92.5399 117.898 92.5945 117.958 92.6602 118.006C92.7259 118.054 92.8013 118.087 92.8813 118.104C92.9613 118.121 93.0441 118.121 93.1241 118.104C93.2041 118.087 93.2796 118.054 93.3454 118.006C93.4112 117.959 93.4658 117.898 93.5057 117.829C93.5456 117.759 93.5697 117.682 93.5766 117.602C93.6018 117.465 93.6066 117.325 93.5908 117.187Z",
    fill: "#263238"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M98.2299 118.151C98.2234 118.097 98.209 118.043 98.1873 117.992C98.1804 117.965 98.1804 117.936 98.1873 117.909C98.1982 117.888 98.2156 117.871 98.237 117.861C98.4217 117.694 98.1873 117.473 98.0097 117.431C97.9458 117.416 97.879 117.416 97.8155 117.433C97.7521 117.45 97.6942 117.483 97.6474 117.528L97.7966 116.988L98.4502 117.126L98.5212 116.794L97.5408 116.586C97.517 116.631 97.5025 116.681 97.4982 116.731C97.4982 116.78 97.555 116.794 97.5621 116.849C97.5692 116.905 97.5621 116.898 97.5621 116.925C97.5751 116.966 97.6029 117 97.6403 117.022C97.6758 117.022 97.7113 117.085 97.7042 117.126C97.6971 117.168 97.7042 117.126 97.7042 117.168C97.6769 117.233 97.6266 117.288 97.5621 117.32C97.537 117.327 97.5146 117.342 97.4982 117.362C97.4982 117.362 97.4982 117.362 97.4982 117.403C97.4982 117.445 97.4485 117.48 97.4058 117.507C97.3632 117.535 97.2567 117.757 97.214 117.909L97.5692 117.985V117.916C97.6048 117.75 97.6971 117.708 97.8108 117.729C97.9245 117.75 97.9884 117.833 97.9529 117.999L97.8392 118.512C97.8392 118.671 97.7184 118.72 97.5977 118.692C97.4769 118.664 97.42 118.595 97.4556 118.429L97.5053 118.214L97.1501 118.138L97.1075 118.332C97.086 118.404 97.0801 118.481 97.0901 118.556C97.1002 118.631 97.1259 118.704 97.1658 118.769C97.2056 118.834 97.2588 118.89 97.3219 118.934C97.385 118.979 97.4567 119.01 97.5327 119.026C97.6087 119.042 97.6872 119.043 97.7635 119.028C97.8398 119.014 97.9122 118.984 97.9762 118.941C98.0402 118.898 98.0945 118.842 98.1357 118.778C98.1769 118.714 98.2041 118.642 98.2157 118.567C98.2442 118.43 98.249 118.29 98.2299 118.151Z",
    fill: "#263238"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M96.1483 117.645H96.1838C96.1838 117.611 96.1838 117.576 96.1838 117.528H96.3401L96.4609 116.994C96.4882 116.918 96.4986 116.838 96.4916 116.758C96.4846 116.678 96.4602 116.6 96.4201 116.53C96.3799 116.46 96.325 116.399 96.2589 116.351C96.1927 116.303 96.1169 116.269 96.0364 116.252C95.9559 116.234 95.8726 116.234 95.7919 116.25C95.7112 116.267 95.6351 116.3 95.5684 116.347C95.5018 116.394 95.4462 116.455 95.4053 116.525C95.3644 116.594 95.3392 116.672 95.3313 116.752V116.849C95.381 116.89 95.4095 116.96 95.4592 116.994C95.5089 117.029 95.5871 116.994 95.5658 117.112C95.5444 117.23 95.5231 117.209 95.5658 117.244C95.6084 117.278 95.6155 117.244 95.6226 117.292C95.6312 117.303 95.6359 117.317 95.6359 117.33C95.6359 117.344 95.6312 117.357 95.6226 117.368C95.6226 117.368 95.5729 117.368 95.5658 117.431C95.5587 117.493 95.5658 117.535 95.5231 117.549C95.4805 117.562 95.3881 117.465 95.31 117.472C95.282 117.48 95.2567 117.495 95.2367 117.516C95.2167 117.537 95.2028 117.562 95.1963 117.59C95.1601 117.708 95.134 117.828 95.1182 117.95C95.0923 118.024 95.0833 118.102 95.0918 118.179C95.1004 118.256 95.1263 118.33 95.1677 118.396C95.2091 118.462 95.2649 118.519 95.3313 118.561C95.3977 118.604 95.4729 118.632 95.5515 118.643C95.6323 118.664 95.7168 118.668 95.7991 118.653C95.8813 118.639 95.9593 118.607 96.0275 118.56C96.0904 118.507 96.1433 118.444 96.1838 118.373C96.2158 118.337 96.2334 118.292 96.2334 118.245C96.2334 118.198 96.2158 118.152 96.1838 118.117H96.1483L96.0986 117.95C96.0986 117.95 96.0986 117.95 96.1483 117.909C96.198 117.867 96.1483 117.777 96.2193 117.729C96.2904 117.68 96.1341 117.659 96.1483 117.645ZM95.8499 118.117C95.8144 118.283 95.7221 118.331 95.6013 118.304C95.4805 118.276 95.4237 118.2 95.4592 118.033L95.7434 116.787C95.7789 116.62 95.8641 116.572 95.9849 116.599C96.1057 116.627 96.1625 116.703 96.127 116.87L95.8499 118.117Z",
    fill: "#263238"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M96.7811 118.502L96.7029 118.856L96.3401 118.779L96.4184 118.426L96.7811 118.502Z",
    fill: "#263238"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7502 117.881C99.7928 117.881 99.7928 117.722 99.807 117.666C99.8343 117.59 99.8448 117.51 99.8377 117.43C99.8307 117.35 99.8063 117.272 99.7662 117.202C99.7261 117.131 99.6711 117.07 99.605 117.022C99.5389 116.974 99.463 116.941 99.3826 116.923C99.3021 116.906 99.2187 116.906 99.138 116.922C99.0574 116.939 98.9812 116.972 98.9145 117.019C98.8479 117.066 98.7923 117.127 98.7514 117.197C98.7106 117.266 98.6853 117.344 98.6774 117.424L98.5709 117.888C98.6632 117.971 98.5709 118.103 98.6135 118.2C98.6561 118.297 98.6135 118.2 98.6135 118.241C98.6135 118.283 98.5069 118.304 98.5069 118.359C98.5069 118.359 98.5069 118.414 98.5069 118.359C98.5069 118.359 98.4501 118.442 98.4146 118.484C98.3922 118.517 98.3799 118.555 98.3791 118.594C98.3518 118.67 98.3413 118.751 98.3483 118.831C98.3554 118.911 98.3798 118.989 98.4199 119.059C98.46 119.129 98.515 119.19 98.5811 119.238C98.6472 119.286 98.723 119.32 98.8035 119.337C98.884 119.354 98.9674 119.355 99.0481 119.338C99.1287 119.322 99.2049 119.289 99.2715 119.242C99.3382 119.194 99.3938 119.134 99.4347 119.064C99.4755 118.994 99.5007 118.917 99.5086 118.837L99.5939 118.456C99.5939 118.359 99.7218 118.103 99.5939 118.026C99.466 117.95 99.5371 118.026 99.5229 117.978C99.5141 117.962 99.5096 117.944 99.5096 117.926C99.5096 117.908 99.5141 117.89 99.5229 117.874C99.6081 117.805 99.672 117.923 99.7502 117.881ZM99.3168 118.491C99.3168 118.532 99.2458 118.546 99.2103 118.601C99.1829 118.67 99.1662 118.743 99.1605 118.816C99.125 118.982 99.0327 119.024 98.919 119.003C98.8053 118.982 98.7343 118.899 98.7769 118.733C98.7769 118.685 98.8408 118.546 98.8266 118.504C98.8124 118.463 98.7556 118.504 98.7272 118.421C98.7059 118.349 98.7059 118.272 98.7272 118.2C98.7306 118.184 98.7306 118.167 98.7272 118.151C98.7272 118.151 98.6917 118.089 98.7272 118.061C98.7272 118.061 98.7627 118.033 98.7272 118.061C98.7272 118.061 98.7272 117.971 98.7272 117.909C98.7272 117.846 98.7272 117.909 98.7272 117.909C98.9545 117.992 98.9474 117.652 98.9829 117.514C99.0184 117.375 99.1108 117.299 99.2245 117.327C99.3381 117.354 99.4021 117.431 99.3666 117.59C99.3183 117.731 99.2897 117.878 99.2813 118.026C99.311 118.031 99.3383 118.045 99.3589 118.066C99.3795 118.088 99.3922 118.115 99.395 118.144C99.3879 118.181 99.3879 118.218 99.395 118.255C99.395 118.255 99.395 118.317 99.395 118.345C99.395 118.373 99.3524 118.345 99.3239 118.345C99.3043 118.353 99.2869 118.365 99.2732 118.381C99.2596 118.396 99.2502 118.415 99.2458 118.435L99.3168 118.491Z",
    fill: "#263238"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M95.7789 112.848L98.1802 113.36",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3229 111.68L94.5855 112.594",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M89.9677 113.285L92.7809 113.881",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M65.3514 218.064C69.0846 217.111 72.9235 216.609 76.7821 216.568C83.7159 216.401 88.1489 217.683 93.8323 214.94C99.5157 212.196 103.203 217.136 108.638 214.392C114.072 211.649 116.594 207.257 119.734 207.354C122.875 207.451 127.549 158.386 129.055 149.942C130.561 141.498 133.765 117.959 134.867 113.18L128.679 219.56L65.3514 218.064Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M65.6498 197.133L82.9771 217.686L64.6765 216.577L65.6498 197.133Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M111.636 156.486L111.358 164.307C111.32 165.398 111.061 166.472 110.597 167.465C110.133 168.459 109.473 169.354 108.655 170.099C107.836 170.844 106.875 171.424 105.826 171.807C104.777 172.189 103.661 172.367 102.542 172.329L94.3012 172.045C93.1789 172.007 92.0754 171.754 91.0538 171.3C90.0323 170.845 89.1129 170.198 88.3485 169.396C87.584 168.594 86.9896 167.653 86.5994 166.626C86.2091 165.599 86.0307 164.508 86.0745 163.414L86.4439 153.231C86.5235 151.028 87.497 148.946 89.1503 147.443C90.8035 145.941 93.0013 145.139 95.2603 145.216L103.501 145.493C103.729 145.493 103.956 145.493 104.212 145.542C103.058 146.623 102.331 148.065 102.155 149.615C101.978 151.166 102.365 152.728 103.248 154.029C104.131 155.331 105.453 156.289 106.986 156.738C108.518 157.187 110.163 157.098 111.636 156.486Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M113.12 149.735C113.095 150.486 112.841 151.214 112.391 151.825C111.941 152.436 111.315 152.904 110.593 153.168C109.871 153.432 109.084 153.482 108.333 153.311C107.582 153.139 106.9 152.754 106.373 152.205C105.846 151.655 105.498 150.966 105.373 150.223C105.249 149.481 105.352 148.719 105.672 148.034C105.991 147.349 106.511 146.772 107.167 146.376C107.823 145.979 108.584 145.781 109.355 145.807C110.388 145.843 111.364 146.277 112.069 147.013C112.775 147.749 113.153 148.727 113.12 149.735Z",
    fill: "#374DA0",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M88.4189 164.393L100.532 154.293C100.532 154.293 98.9971 148.883 100.532 147.172H94.7133C93.312 147.167 91.9619 147.685 90.9387 148.618C89.9154 149.551 89.2962 150.831 89.2075 152.194L88.4189 164.393Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M107.572 149.945L110.165 147.174C110.165 147.174 108.552 146.114 107.572 147.174C106.592 148.234 107.572 149.945 107.572 149.945Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M106.307 210.285L125.837 211.109",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5442 212.207L125.837 213.579",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M118.953 217.684H125.837",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.0187 147.74C84.9449 152.464 74.0328 135.915 70.2107 133.636C69.2684 133.056 68.3899 132.383 67.5892 131.627L69.2516 104.473L98.7414 105.629C98.5495 109.675 98.6135 114.143 99.537 116.713C101.526 122.317 105.085 143.022 95.0187 147.74Z",
    fill: "black",
    fillOpacity: 0.7
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M83.7301 148.589C83.7301 148.589 91.7863 151.997 95.4379 149.975C99.0895 147.952 103.025 144.087 103.586 135.504C103.586 135.504 108.382 147.592 98.713 151.215C89.0441 154.838 83.7301 148.589 83.7301 148.589Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M80.5901 153.417C80.5901 153.417 96.9298 157.698 103.92 149.953C103.92 149.953 102.983 154.255 95.438 155.495C87.8932 156.735 80.5901 153.417 80.5901 153.417Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M106.869 125.745C105.625 123.591 107.153 142.953 107.153 142.953C107.153 142.953 109.398 130.165 106.869 125.745Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M136.834 107.119L129.943 221.244L62.2469 219.076L67.5893 131.627L69.2517 104.473L98.7485 105.629L136.834 107.119Z",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M133.41 221.85L130.945 221.24L136.834 116.73L137.879 123.63L133.41 221.85Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0187 147.738C94.0871 148.221 93.0512 148.481 91.9963 148.496C90.9415 148.512 89.8979 148.283 88.9517 147.828C87.314 146.99 85.9927 145.665 85.1793 144.046C82.3731 139.114 74.7787 127.878 73.3792 124.65C71.9796 121.422 68.8822 112.292 65.7918 108.461C62.7015 104.63 61.0107 98.867 61.0107 98.867L59.8882 42.9648C61.5719 51.0488 66.211 60.2273 66.211 60.2273C70.2415 62.2723 73.6661 65.2919 76.1569 68.9971C76.882 69.75 77.5314 70.5688 78.0964 71.4424C82.6857 78.3695 84.9094 90.8384 85.1509 100.536C85.4351 111.502 89.0867 116.469 94.9903 126.021C100.894 135.574 98.855 145.611 95.0187 147.738Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M95.0188 147.74C94.0835 148.211 93.0488 148.464 91.9962 148.48C90.9435 148.496 89.9015 148.273 88.9518 147.83C92.1772 146.971 96.4113 145.357 95.438 142.981C93.9106 139.185 89.442 144.817 87.1971 142.981C84.9521 141.145 76.7964 130.616 81.9754 125.982C87.1544 121.348 85.5276 113.575 81.9754 111.386C78.4233 109.197 80.7322 103.981 81.8547 95.7726C82.5651 90.8058 80.1283 79.5561 78.1249 71.4375C82.7143 78.3647 84.9379 90.8335 85.1795 100.532C85.4636 111.497 89.1152 116.464 95.0188 126.017C100.922 135.569 98.8551 145.745 95.0188 147.74Z",
    fill: "#374DA0"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8882 42.9336C61.5719 51.0176 66.211 60.1961 66.211 60.1961C70.2415 62.2411 73.6661 65.2607 76.1569 68.9658C82.0606 74.9925 84.8738 89.5187 85.1509 100.477C85.428 111.436 89.0867 116.41 94.9903 125.962C100.894 135.515 99.2528 145.476 94.9903 147.741C92.0207 149.328 87.9642 148.981 85.1509 144.049C82.3376 139.117 74.7503 127.881 73.3507 124.653C71.9512 121.425 68.8538 112.295 65.7634 108.464C62.6731 104.634 60.9822 98.8704 60.9822 98.8704",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M78.139 123.637C78.139 123.637 82.7284 123.235 84.8312 121.559",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M59.3271 99.9648C59.3271 99.9648 58.4319 102.043 63.1207 104.121",
    stroke: "#263238",
    strokeWidth: 1.41305,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCashpayment);
export default __webpack_public_path__ + "static/media/cashpayment.cf3e75f00aeb5fc6fd5adf47e7965a29.svg";
export { ForwardRef as ReactComponent };